import React from 'react'
import { M_DrawerTableTextField } from 'src/components/M_Components'
import M_RadioButton from 'src/components/M_Components/M_RadioButton/M_RadioButton'

export default function Receiver({ orderService, optionsOrderService, optionsReceiver, setOrderService, validateReceiver, t }) {

    return (
        <div className='divCardSmall'>
            <div className='divTitleCard'>
                <div className='divSizeTitle'>
                    <div className='iconTitleCard'>
                        <img src="/icons/svgsDaNet/flag-1.5.svg"
                            style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                            alt="Receiver"
                        />
                    </div>
                    <div className='labelTitleCard'>
                        {t("Entities")}
                    </div>
                </div>
            </div>
            <div className='marginTopInputReceiver'>

                {optionsOrderService.filter((elems) => elems.GroupByInfo === 'Recetor').map((elem6, key6) => (
                    <div key={key6}>
                        {elem6.Type === 'string' ? (
                            <M_DrawerTableTextField
                                tableLabel={elem6.NormalizedName}
                                label={elem6.NormalizedName}
                                required={orderService.get('SelectedReceiver') !== 'Other' ? elem6.Name === 'Shipper' ? false : true : true}
                                entity={elem6.ForeignTableName}
                                value={orderService.get(elem6.ForeignTableToPassId) ?
                                    {
                                        [elem6.ForeignTableToPassId]: orderService.get(elem6.ForeignTableToPassId),
                                        [elem6.ForeignKeyName]: orderService.get(elem6.Name)
                                    } : null}
                                filterField={elem6.ForeignKeyName}
                                labelFields={[elem6.ForeignKeyName]}
                                onSubmitValue={obj => {
                                    if (obj) {
                                        orderService.set(elem6.Name, obj[elem6.ForeignKeyName])
                                        orderService.set(elem6.ForeignTableToPassId, obj[elem6.ForeignTableToPassId])
                                    } else {
                                        orderService.set(elem6.Name, null)
                                        orderService.set(elem6.ForeignTableToPassId, null)
                                    }
                                    setOrderService(new Map(orderService))
                                }}
                                disabled={orderService.get('SelectedReceiver') !== 'Other' ? elem6.Name === 'Shipper' ? true : false : null}
                                valueField={elem6.ForeignTableToPassId}
                            />
                        ) :  elem6.Type === 'boolean' && key6 === 1 ? (
                            <M_RadioButton
                                options={optionsReceiver}
                                onChange={(e) => validateReceiver(e.target.value)}
                                selectedValue={orderService.get('SelectedReceiver') || ""}
                                required={true}
                            />
                        ) : null}
                    </div>
                ))}
            </div>
        </div>
    )
}